import { render, staticRenderFns } from "./GreenWasteForm.vue?vue&type=template&id=e738cc0c&scoped=true&"
import script from "./GreenWasteForm.vue?vue&type=script&lang=js&"
export * from "./GreenWasteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e738cc0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e738cc0c')) {
      api.createRecord('e738cc0c', component.options)
    } else {
      api.reload('e738cc0c', component.options)
    }
    module.hot.accept("./GreenWasteForm.vue?vue&type=template&id=e738cc0c&scoped=true&", function () {
      api.rerender('e738cc0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/GreenWasteForm.vue"
export default component.exports